<div class="property-item"
     [ngClass]="{'selected': selected}">
    <div class="address">
        <div class="location-icon">
            <i class="fas fa-map-marker map-marker"></i>
        </div>
        <div>
            <div class="street">
                {{address}}
            </div>
            <div class="state">
                {{publicRecord.propertyRecord.city}}, {{publicRecord.propertyRecord.state}}
                {{publicRecord.propertyRecord.postalCode}}
            </div>
            <div class="coordinates">
                <!-- 1675 W / 560 N -->
            </div>
        </div>
    </div>
    <div>
        <div class="tax-id">
            <i class="fas fa-file"></i> {{publicRecord.propertyRecord.parcelNumber}}
        </div>
        <div class="record">
            <!-- Black Knight Public Records -->
        </div>
    </div>
</div>
